const generateUniqueIdForPopup = () => `popupItem-${Math.random().toString(36).substr(2, 9)}`;

export const storefrontPopupDefaultTextData = {
    key: "text",
    label: "New Text",
    position: "row",
    id: generateUniqueIdForPopup(),
    deviceType: {
        desktop: true,
        tabletlarge: true,
        tablet: true,
        mobilelarge: true,
        mobile: true
    },
    align: "left",
    desktopStyles: {
        lineHeight: "1.2",
        color: "inhert",
        backgroundColor: "#00000000",
        fontSize: "16px",
        fontWeight: "300",
        fontFamily: "inherit",
        fontStyle: "normal",
        display: "block",
        margin: "0px",
        padding: "0px"
    },
    tabletlargeStyles: {},
    tabletStyles: {},
    mobilelargeStyles: {},
    mobileStyles: {}
}

export const storefrontPopupDefaultButtonData = {
    key: "button",
    label: "Submit",
    position: "row",
    id: generateUniqueIdForPopup(),
    deviceType: {
        desktop: true,
        tabletlarge: true,
        tablet: true,
        mobilelarge: true,
        mobile: true
    },
    align: "left",
    action: "none",
    desktopStyles: {
        color: "#000",
        backgroundColor: "#fff",
        fontSize: "16px",
        fontWeight: 300,
        fontFamily: "inherit",
        fontStyle: "normal",
        display: "block",
        margin: "0px",
        padding: "5px",
        height: "auto",
        width: "auto",
        borderRadius: "5px",
        borderColor: "#ccc",
        borderWidth: "1px"
    },
    tabletlargeStyles: {},
    tabletStyles: {},
    mobilelargeStyles: {},
    mobileStyles: {}
}

export const storefrontPopupDefaultLinkData = {
    key: "link",
    label: "Submit",
    position: "row",
    id: generateUniqueIdForPopup(),
    deviceType: {
        desktop: true,
        tabletlarge: true,
        tablet: true,
        mobilelarge: true,
        mobile: true
    },
    align: "center",
    href: "",
    target: "_blank",
    desktopStyles: {
        color: "inherit",
        fontSize: "16px",
        fontWeight: 300,
        fontFamily: "inherit",
        fontStyle: "normal",
        display: "inline",
        margin: "0px",
        padding: "5px",
        height: "auto",
        width: "100%",
        textAlign: "center",
        lineHeight: 1.2
    },
    tabletlargeStyles: {},
    tabletStyles: {},
    mobilelargeStyles: {},
    mobileStyles: {}
}

export const storefrontPopupDefaultImageData = {
    key: "image",
    label: "Popup Image",
    position: "row",
    id: generateUniqueIdForPopup(),
    deviceType: {
        desktop: true,
        tabletlarge: true,
        tablet: true,
        mobilelarge: true,
        mobile: true
    },
    src: "https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?ixid=M3wxMzIxMjl8MHwxfHNlYXJjaHwxOHx8Y2xvdGhlc3xlbnwwfHx8fDE3NTI2NTg4MTl8MA&ixlib=rb-4.1.0&fit=max&w=2000&h=2000",
    desktopStyles: {
        height: "300px",
        width: "100%",
        display: "block",
        margin: "0px",
        padding: "0px"
    },
    tabletlargeStyles: {},
    tabletStyles: {},
    mobilelargeStyles: {},
    mobileStyles: {}
}

export const storefrontPopupDefaultSpacingData = {
    key: "spacing",
    label: "Spacing",
    position: "row",
    id: generateUniqueIdForPopup(),
    deviceType: {
        desktop: true,
        tabletlarge: true,
        tablet: true,
        mobilelarge: true,
        mobile: true
    },
    desktopStyles: {
        height: "10px",
        width: "100%",
    },
    tabletlargeStyles: {},
    tabletStyles: {},
    mobilelargeStyles: {},
    mobileStyles: {}
}

export const storefrontPopupDefaultCouponData  = {
    key: "coupon",
    label: "Coupon Code",
    clickToCopy: "Click To Copy",
    copiedText: "COPIED!",
    position: "row",
    align: "center",
    id: generateUniqueIdForPopup(),
    deviceType: {
        desktop: true,
        tabletlarge: true,
        tablet: true,
        mobilelarge: true,
        mobile: true
    },
    desktopStyles: {
        color: "#000",
        backgroundColor: "#fff",
        fontSize: "16px",
        fontWeight: 300,
        fontFamily: "inherit",
        fontStyle: "normal",
        display: "block",
        margin: "0px",
        padding: "5px",
        height: "auto",
        width: "auto",
        borderRadius: "5px",
        borderColor: "#ccc",
        borderWidth: "2px",
        borderStyle: "dotted",
        textAlign: "center",
        cursor: "pointer"
    },
    tabletlargeStyles: {},
    tabletStyles: {},
    mobilelargeStyles: {},
    mobileStyles: {}
}

export const storefrontPopupDefaultFrequencySelect = {
    key: "frequency",
    label: "Frequency",
    position: "row",
    id: generateUniqueIdForPopup(),
    deviceType: {
        desktop: true,
        tabletlarge: true,
        tablet: true,
        mobilelarge: true,
        mobile: true
    },
    required: true,
    name: "frequency",
    desktopStyles: {
        color: "#000",
        backgroundColor: "#fff",
        fontSize: "16px",
        fontWeight: 300,
        fontFamily: "inherit",
        fontStyle: "normal",
        display: "block",
        margin: "0px",
        padding: "5px",
        maxHeight: "500px",
        maxWidth: "100%",
        height: "auto",
        width: "100%",
        borderRadius: "5px",
        borderColor: "#ccc",
        borderWidth: "1px"
    },
    tabletlargeStyles: {},
    tabletStyles: {},
    mobilelargeStyles: {},
    mobileStyles: {}
}

export const storefrontPopupDefaultInputData  = {
    key: "input",
    label: "Email",
    position: "row",
    id: generateUniqueIdForPopup(),
    deviceType: {
        desktop: true,
        tabletlarge: true,
        tablet: true,
        mobilelarge: true,
        mobile: true
    },
    required: false,
    name: "emailAddress",
    desktopStyles: {
        color: "#000",
        backgroundColor: "#fff",
        fontSize: "16px",
        fontWeight: 300,
        fontFamily: "inherit",
        fontStyle: "normal",
        display: "block",
        margin: "0px",
        padding: "5px",
        maxHeight: "500px",
        maxWidth: "100%",
        height: "auto",
        width: "100%",
        borderRadius: "5px",
        borderColor: "#ccc",
        borderWidth: "1px"
    },
    tabletlargeStyles: {},
    tabletStyles: {},
    mobilelargeStyles: {},
    mobileStyles: {}
}

export const storefrontPopupComponentDefaultDataMap = {
    "text": storefrontPopupDefaultTextData,
    "button": storefrontPopupDefaultButtonData,
    "image": storefrontPopupDefaultImageData,
    "spacing": storefrontPopupDefaultSpacingData,
    "link": storefrontPopupDefaultLinkData,
    "coupon": storefrontPopupDefaultCouponData,
    "input": storefrontPopupDefaultInputData,
    "frequency": storefrontPopupDefaultFrequencySelect
}